import { render, staticRenderFns } from "./HistoryPatrimony.vue?vue&type=template&id=a94c437c&"
import script from "./HistoryPatrimony.vue?vue&type=script&lang=js&"
export * from "./HistoryPatrimony.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPatrimony.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports